/** Api methods */
import * as AnalyticsApi from './api/analytics'
import * as ApplicationApi from './api/application'
import * as AuthApi from './api/auth'
import * as BlockApi from './api/block'
import * as BrainApi from './api/brain'
import * as ChatApi from './api/chat'
import * as ChatbotApi from './api/chatbot'
import * as CompaniesApi from './api/companies'
import * as ContentApi from './api/content'
import * as HealthApi from './api/health'
import * as IntegrationApi from './api/integration'
import * as NotificationApi from './api/notifications'
import * as OnboardingApi from './api/onboarding'
import * as RatingApi from './api/rating'
import * as UserApi from './api/user'
import * as UserApplicationApi from './api/userapplication'
import * as UserBrainApi from './api/userbrain'
/** Chatbot Api methods */
import * as AuthChatbotApi from './chatbot-api/auth'
import * as ChatbotChatbotApi from './chatbot-api/chatbot'
import * as HealthChatbotApi from './chatbot-api/health'
import * as UploadContentApi from './content-api/content'

export const ApiCaller = {
	...AnalyticsApi,
	...AuthApi,
	...BrainApi,
	...ChatApi,
	...ChatbotApi,
	...CompaniesApi,
	...ContentApi,
	...HealthApi,
	...IntegrationApi,
	...OnboardingApi,
	...UserApi,
	...ApplicationApi,
	...NotificationApi,
	...BlockApi,
	...UserBrainApi,
	...RatingApi,
	...UserApplicationApi
}

export const ChatbotApiCaller = {
	...AuthChatbotApi,
	...ChatbotChatbotApi,
	...HealthChatbotApi
}

export const ContentApiCaller = {
	...UploadContentApi
}
